
import React from 'react';
import FeesPayment from '../components/FeesPayment';
import Footer from '../components/Footer';


function FeesPaymentPage () {
  return (
    <>
        <FeesPayment />
        <Footer />
    </>
  );
}


export default FeesPaymentPage;
